import { Button } from "@rumbledirect/ui";
import { TableColumnsType } from "antd";
import { Link } from "react-router-dom";
import { ReplacementTransportOption } from "@rumble-it/common-lib/types/models/ReplacementTransportOption.interface";
import { EyeOutlined } from "@ant-design/icons";

export const replacementTransportOptionColumns: TableColumnsType<ReplacementTransportOption> =
  [
    {
      title: "Naam",
      dataIndex: "title",
      key: "name",
      render: (text: string, record: any) => (
        <Link to={`/replacement-transport/options/${record.id}`}>{text}</Link>
      ),
    },
    {
      title: "Beschrijving",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Acties",
      key: "actions",
      render: (_: any, record) => (
        <Link to={`/replacement-transport/options/${record.id}`}>
          <Button icon={<EyeOutlined />} variant="light" />
        </Link>
      ),
    },
  ];
